import { render, staticRenderFns } from "./TagInsertData.vue?vue&type=template&id=93a0dc96&scoped=true&"
import script from "./TagInsertData.vue?vue&type=script&lang=js&"
export * from "./TagInsertData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a0dc96",
  null
  
)

export default component.exports